<template>
  <div class="relative lg:mb-0" v-on-click-outside="close">
    <!-- toggle "is-active" class on .js-btn-toggler -->
    <a class="button flex items-center justify-center" href="#" :class="[buttonClass, { 'is-active': expanded }]" @click.prevent="expand()">
      <span class="mr-2 whitespace-nowrap" v-text="orderSelected"></span>
      <svg class="transition-all transform" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.83301 1.64554L5.33951 6.13729C5.23294 6.2743 5.06908 6.35443 4.89551 6.35443C4.72193 6.35443 4.55808 6.2743 4.45151 6.13729L0.958008 1.64554"
          stroke="#1B83A2"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>

    <!-- toggle .hidden class -->
    <div class="absolute left-0 top-105 z-10 pt-4 rounded-b-lg bg-white shadow w-64" v-show="expanded">
      <div class="pb-2 border-b border-gray-300">
        <label
          v-for="(o, key) in orders"
          :key="key"
          @click="sort(key)"
          class="flex items-center px-2 py-2 mx-2 text-md cursor-pointer hover:bg-semanticInfoLight rounded"
          :for="`key_${key}`"
        >
          <input class="hidden" type="radio" :name="name" :value="`${key}`" v-model="current" :id="`key_${key}`" />
          <span class="checkbox flex items-center justify-center w-6 h-6 mr-2 border border-gray-500 rounded-full bg-white">
            <span class="w-2 h-2 rounded-full bg-white"></span>
          </span>
          <span class="flex-1" v-text="o.text"></span>
        </label>
      </div>
      <div class="px-4 py-4">
        <a class="flex items-center hover:text-btnBg" href="#" @click.prevent="clear">
          <img class="relative -left-1" :src="`${$settings.theme_url}/assets/images/icons/icn-blue-clear.svg`" width="32" height="32" alt="" />
          Reset
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import FacetsMixin from "./../../mixins/facets.js"
export default {
  mixins: [FacetsMixin],
  props: {
    orders: {
      type: [Array, Object],
      default: () => ({}),
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Facet",
    },
    buttonClass: {
      type: String,
      default: "mr-4",
    },
    name: {
      type: String,
      default: "sort",
    },
  },
  data() {
    return {
      open: false,
      current: "",
    }
  },
  computed: {
    orderSelected() {
      return this.orders[this.value]?.display ?? "Sort by"
    },
  },
  mounted() {
    this.load()
  },
  watch: {
    value() {
      this.load()
    },
  },
  methods: {
    load() {
      this.current = this.value
    },
    close() {
      this.expanded = false
    },
    clear() {
      this.sort("relevance")
      this.$emit("clear")
      this.expanded = false
    },
    sort(order) {
      this.$emit("sort", order)
      this.$emit("input", order)
      this.$events.$emit("close-facets-" + this.$parent.name)
      this.close()
    },
  },
}
</script>
